<template>
  <CFooter>
    <div>
      <a href="https://superformicf.ca/" target="_blank">SuperForm Products</a>
      <span class="ml-1">&copy; {{ (new Date()).getFullYear() }}</span>
    </div>
    <div class="ml-auto">
      <img width="20" src="img/brand/sf-logo-mini.svg">
    </div>
  </CFooter>
</template>

<script>
export default {
  name: 'TheFooter'
}
</script>
